import { DatasourcesStatusOutputV1 } from '@/sdk';
import { flux } from '@/core/flux.module';

export function setDatasources(datasources: DatasourcesStatusOutputV1) {
  flux.dispatch('DATASOURCES_SET_DATASOURCES', { datasources });
}
